import { render, staticRenderFns } from "./ProductDialogList.vue?vue&type=template&id=4f284df0&"
import script from "./ProductDialogList.vue?vue&type=script&lang=js&"
export * from "./ProductDialogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports